import React from "react";

export default function JobAssignments({ job, prodLogs, machines, team }) {
  const plan = (job.machine_plan || []).filter((r) => r.machine_id);

  const loggedByMachine = {};
  (prodLogs || []).forEach((p) => {
    if (p.machine_id) loggedByMachine[p.machine_id] = (loggedByMachine[p.machine_id] || 0) + (Number(p.actual_hours) || 0);
  });

  const name = (list, id, field) => {
    const r = (list || []).find((x) => x.id === id);
    return r ? `${r.code} · ${r[field] || ""}` : "—";
  };

  if (plan.length === 0) {
    return (
      <div className="p-5 text-sm text-slate-400" data-testid="job-assignments-empty">
        No machines allocated yet. Edit this job to add machines with planned hours and operators.
      </div>
    );
  }

  return (
    <ul className="divide-y divide-slate-200" data-testid="job-machine-plan">
      {plan.map((row) => {
        const planned = Number(row.planned_hours) || 0;
        const logged = Math.round((loggedByMachine[row.machine_id] || 0) * 10) / 10;
        const over = planned > 0 && logged > planned;
        return (
          <li key={row.machine_id} className="p-4 sm:px-5" data-testid={`job-machine-${row.machine_id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="text-sm font-medium text-slate-900">{name(machines, row.machine_id, "machine_name")}</span>
              <span className={`text-sm tabular-nums ${over ? "text-red-600 font-semibold" : "text-slate-600"}`}>
                {logged} / {planned || "—"} h logged
              </span>
            </div>
            {planned > 0 && (
              <div className="mt-2 h-1.5 rounded-full bg-slate-100 overflow-hidden">
                <div className={`h-full ${over ? "bg-red-500" : "bg-emerald-500"}`}
                  style={{ width: `${Math.min(100, (logged / planned) * 100)}%` }} />
              </div>
            )}
            <div className="mt-2 flex flex-wrap gap-1.5">
              {(row.operator_ids || []).length === 0 ? (
                <span className="text-xs text-slate-400">No operator allocated</span>
              ) : (row.operator_ids || []).map((oid) => (
                <span key={oid} className="rounded-md bg-slate-100 px-2 py-1 text-xs text-slate-600">
                  {name(team, oid, "name")}
                </span>
              ))}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
